// extracted by mini-css-extract-plugin
export default {"root":"DepartmentMenuItem_root__-DssK","button":"DepartmentMenuItem_button__WCnM0","menuItemLink":"DepartmentMenuItem_menuItemLink__QXsf0"};